const de = {
  alerts: {
    saveSuccessful: 'Das Stellenangebot wurde erfolgreich aktualisiert.',
    saveFailed: 'Das Stellenangebot konnte nicht aktualisiert werden.',
    deleteSuccessful: 'Das Stellenangebot wurde erfolgreich gelöscht.',
    deleteFailed: 'Das Stellenangebot konnte nicht geöscht werden.',
    errorLoading: 'Das Stellenangebot konnte nicht geladen werden.'
  },
  createNew: 'Neues Stellenangebot',
  title: 'Titel',
  displayPeriod: 'Anzeigezeitraum',
  periodStart: 'Startdatum',
  priceCategories: 'Preiskategorien',
  paidCategoriesInformation: 'Kostenpflichtige Kategorien sind mit * markiert',
  detailView: 'Detailansicht',
  edit: 'Bearbeiten',
  delete: 'Angebot löschen',
  jobOfferView: 'Stellenangebot',
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie dieses Stellenangebot unwiderruflich löschen?'
  },
  addPeriod: {
    title: 'Anzeigezeitraum verlängern',
    message: 'Wollen Sie den Anzeigezeitraum um {{interval}} verlängern?',
    messageNoInterval: 'Wollen Sie den Anzeigezeitraum verlängern?'
  },
  deletePeriod: {
    title: 'Anzeigezeitraum löschen',
    message: 'Wollen Sie den Anzeigezeitraum löschen?'
  },
  attachementUploadPlaceholder: 'Anhang hochladen (pdf, doc(x), zip)',
  attachementUploadInfo: 'Maximale Uploadgröße: {{size}}',
  factors: {
    day: '{{duration}} Tag',
    day_plural: '{{duration}} Tage',
    week: '{{duration}} Woche',
    week_plural: '{{duration}} Wochen',
    month: '{{duration}} Monat',
    month_plural: '{{duration}} Monate',
    year: '{{duration}} Jahr',
    year_plural: '{{duration}} Jahre'
  },
  paid: 'Kostenpflichtig',
  externalLink: 'Link zu externem Bewerberportal',
  externalLinkTooltip:
    '(Optional) Dieser Link wird dann anstelle der Email zum Einreichen der Bewerbung verwendet.'
};
export default de;
export type ManageJobOffersTranslation = typeof de;
